import { axiosInstance } from '@src/services/common';

export async function getDimensions() {
  const response = await axiosInstance.post<{ dimensions: Dimension[] }>(`/gm/v1/dimensions/list`);

  return response.data.dimensions;
}

export async function getDimension(id: string) {
  const response = await axiosInstance.get<Dimension>(`/gm/v1/dimensions/${id}`);

  return response.data;
}

export async function postDimension() {}

export async function putDimension() {}

export async function deleteDimension(id: string) {
  await axiosInstance.delete(`/gm/v1/dimensions/${id}`);
}
